'use client';

import { getGoogleRating } from '@/service/api/GoogleRating/getGoogleRating';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export const useTourPartnerName = (regularName: string, partnerId: string) => {
    const pathname = usePathname();
    const [partnerName, setPartnerName] = useState(regularName);

    const isTourPage = pathname.includes('/tour/');

    useEffect(() => {
        if (isTourPage && partnerId) {
            (async () => {
                const googleName = await getGoogleRating(partnerId, 'google_name');

                if (googleName?.google_name) {
                    setPartnerName(googleName.google_name);
                }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTourPage, partnerId]);

    return isTourPage && partnerName === regularName ? '' : partnerName;
};
